import { GETSETTINGINVOICEDETAILS_SUCCESS, GETSETTINGINVOICEDETAILS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getSettingInvoiceDetailesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETSETTINGINVOICEDETAILS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETSETTINGINVOICEDETAILS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getSettingInvoiceDetailesReducer;
